

export function RenderIf({ condition, children }) {
    return condition ? children : null;
}